/*
 Copyright 2016 Google Inc. All Rights Reserved.
 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/

import WorkboxSW from '../../src';

describe(`Test Directory Index`, function() {
  it(`should throw on bad input`, function() {
    const badInputs = [
      '',
      {},
      [],
      123,
    ];
    badInputs.forEach((badInput) => {
      let caughtError;
      try {
        new WorkboxSW({
          directoryIndex: badInput,
        });
        throw new Error('Expected error to be thrown.');
      } catch (err) {
        caughtError = err;
      }
      if (caughtError.name !== 'bad-directory-index') {
        console.error(caughtError);
        throw new Error('Unexpected error thrown.');
      }
    });
  });
});
